import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'videos',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'videosApi',
  baseQuery,
  tagTypes: ['videos'],
  endpoints: builder => ({
    getVideos: builder.query({
      query: () => ({
        url: endpoints.VIDEOS,
        method: 'GET',
      }),
      providesTags: ['videos'],
    }),
    getVideosCategories: builder.query({
      query: () => ({
        url: endpoints.VIDEOS + '/category',
        method: 'GET',
      }),
      providesTags: ['videos'],
    }),

    addVideos: builder.mutation({
      query: data => ({
        url: endpoints.VIDEOS + '/create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['videos'],
    }),
  }),
});

export const { actions: VideosActions } = slice;

export const useVideosSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: VideosActions,

    useLazyGetVideosQuery: api.useLazyGetVideosQuery,
    useLazyGetVideosCategoriesQuery: api.useLazyGetVideosCategoriesQuery,

    useAddVideosMutation: api.useAddVideosMutation,
  };
};
